import { createSlice } from "@reduxjs/toolkit";
import { getAssetByTimeline } from "services/assetService";
import { DateSelections, getDateRanges } from "utils/helper";
import { logger } from "utils/logger";

const liveFeedSlice = createSlice({
  name: "liveFeedSlice",
  initialState: {
    assets: [],
    selectedAsset: null,
    feedFilter: {
      dataFilter:
      {dateRange: {
        item: DateSelections[4],
        value: [
          getDateRanges(DateSelections[4]).startDate,
          getDateRanges(DateSelections[4]).endDate,
        ],
      }},
      timeRange: ["", ""],
    },
    error: null,
    success: null,
    loading: false,
    action: null,
  },
  reducers: {
    selectAsset(state, action) {
      logger.log("Setting Asset: ", action.payload);
      state.selectedAsset = action.payload ? { ...action.payload } : null;
    },
    setFeedFilter(state, action) {
      logger.log('Setting Filter: ', action.payload);
      state.feedFilter = action.payload ? { ...action.payload } : null;
    },
    //////////////////////
    //
    // GET Assets
    //
    //////////////////////
    getAssetsStart(state, action) {
      state.success = null;
      state.error = null;
    },
    getAssetsSuccess(state, action) {
      logger.log("getSuccess : SUCCESS");

      state.loading = false;
      state.success = { type: action.type, message: "Get Assets Success" };

      state.assets = [...action.payload];
      state.error = null;
    },
    getAssetsFailure(state, action) {
      logger.log(state, action, "fail");
      state.error = action.payload;
    },
    clearNotifications(state, action) {
      state.error = null;
      state.success = null;
    },
  },
});

export const fetchLatestAssets = (criteria) => async (dispatch) => {
  try {
    dispatch(getAssetsStart());
    // const data = await getStyleTimeline({ id: criteria.keyword });
    const data = await getAssetByTimeline(criteria);
    dispatch(getAssetsSuccess(data));
  } catch (err) {
    logger.log("err", err);
    dispatch(getAssetsFailure(err));
  }
};

export const {
  selectAsset,
  getAssetsStart,
  getAssetsSuccess,
  getAssetsFailure,
  clearNotifications,
  setFeedFilter,
} = liveFeedSlice.actions;

export default liveFeedSlice.reducer;

// export default undoable(settingsSlice.reducer,{
//   limit: 20 // set a limit for the size of the history
// })
